/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_PositionInputs */



/**
* | output |
* | --- |
* | "Update Position" |
*
* @param {Update_PositionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_position = /** @type {((inputs?: Update_PositionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_PositionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre à jour la position")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna posizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить позицию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar posición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置を更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar posição")
	return /** @type {LocalizedString} */ ("Update Position")
});